<template>
    <print-layout>
        <div class="print-container">
            <div v-for="(order, index) in orders" :key="index">
                <div style="text-align: center; padding-top: 0px; padding-left: 2px; padding-right: 2px" class="page">
                    <b>{{ order.order_number }}</b><br/>
                    <div class="name (order.shipping_first_name + order.shipping_last_name).length > 25 ? 'small_text' : ''">
                        {{ order.shipping_first_name }}
                        {{ order.shipping_last_name }}
                    </div>
                    <span v-if="order.delivery_zone">
                        <div class="zone order.delivery_zone.name.length > 25 ? 'small_text' : ''">
                            {{ order.delivery_zone.name }}
                        </div>
                    </span>
                </div>

                <div class="page-break"></div>
            </div>
        </div>
    </print-layout>
</template>

<script>
import PrintLayout from '@/Layouts/PrintLayout.vue';


export default {
    components: {
        PrintLayout,
    },

    props: ['orders'],

    methods: {
    },

    mounted () {
        window.print();

        window.onafterprint = function() {
            window.close();
        };
        window.onfocus = function() {
            window.close();
        };
    }
}

</script>

<style>
    body {
        font-size: 90%;
        height: 100%;
    }

    table {
        width: 100%;
    }

    table td {
        -webkit-print-color-adjust: exact;
    }

    .combo_with_integrated_subitems {
        background-color: #EEEEEE;
        color: #515558!important;
    }

    .page-break {
        page-break-after: always;
    }

    .subheader th {
        background: #cbcbcb;
        -webkit-print-color-adjust: exact;
    }
    html, body {
        font-family: verdana;
        font-size: 0.5in;
    }

    h5 {
        color: grey;
        line-height: 30px;
    }

    div.page {
        page-break-before: always;
        page-break-inside: avoid;
    }

    .name, .zone {
        font-size: 0.25in;
    }

    .small_text {
        font-size: 25px !important;
    }

    .zone.small_text {
        font-size: 0.2in !important;
    }   

    .footer {
        position: fixed;
        bottom: 0px;
        left: 0px;
        width: 100%;
    }

    @media screen {
        .print-container {
            display: none;
        }
    }

    .striped tr:nth-child(even):not(.not_striped) {
        background-color: #f2f2f2;
    }
</style>
